import React from 'react';
import { Link } from 'gatsby';

import { Wrapper } from './style';

const HomeButton = ({ isActive }) => {
  return (
    <Wrapper isActive={isActive}>
      <Link to="/">Close</Link>
    </Wrapper>
  );
};

export default HomeButton;
